import type { RuleFilter } from "@reflag/flag-evaluation";
import { z } from "@reflag/shared/utils/zod";

/** The runtime filter protocol, shared by publication and Management API reads. */
export const EffectiveFlagFilterSchema: z.ZodType<RuleFilter> = z
  .lazy(() =>
    z.union([
      z.object({
        type: z.literal("context"),
        field: z.string(),
        operator: z.enum([
          "IS",
          "IS_NOT",
          "ANY_OF",
          "NOT_ANY_OF",
          "CONTAINS",
          "NOT_CONTAINS",
          "GT",
          "LT",
          "AFTER",
          "BEFORE",
          "DATE_AFTER",
          "DATE_BEFORE",
          "SET",
          "NOT_SET",
          "IS_TRUE",
          "IS_FALSE",
        ]),
        values: z.array(z.string()).optional(),
      }),
      z.object({
        type: z.literal("rolloutPercentage"),
        key: z.string(),
        partialRolloutAttribute: z.string(),
        partialRolloutThreshold: z.number().int(),
      }),
      z.object({ type: z.literal("constant"), value: z.boolean() }),
      z.object({
        type: z.literal("group"),
        operator: z.enum(["and", "or"]),
        filters: z.array(EffectiveFlagFilterSchema),
      }),
      z.object({
        type: z.literal("negation"),
        filter: EffectiveFlagFilterSchema,
      }),
    ]),
  )
  .meta({
    id: "effectiveFlagFilter",
    description:
      "A compiled runtime filter with segment and flag references resolved",
  });

export const EffectiveFlagRuleSchema = z
  .object({ filter: EffectiveFlagFilterSchema })
  .meta({
    id: "effectiveFlagRule",
    description:
      "One independent enable rule; a flag is enabled if any rule matches",
  });
